import * as React from 'react';
import { useState } from 'react';
import { InfoIcon } from '../icons/icons';
import Popover from 'react-tiny-popover';

type InfoPopoverProps = {
    children: React.ReactNode;
    className?: string;
};
export const InfoPopover = (props: InfoPopoverProps): JSX.Element => {
    const [isOpen, setOpen] = useState<boolean>(false);
    const InfoIconWithRef = React.forwardRef((_props: {}, ref: React.Ref<HTMLDivElement>) => {
        return (
            <div
                className={props.className || ''}
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                ref={ref}
            >
                <InfoIcon />
            </div>
        );
    });

    return (
        <Popover
            isOpen={isOpen}
            position={'bottom'}
            content={
                <div className="react-tiny-popover-container info-container">
                    {props.children}
                </div>
            }>
            <InfoIconWithRef />
        </Popover>
    );
};
